import {flow, isEmpty} from 'lodash/fp';
import React, {Component, ComponentClass, ReactNode} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';

import {StoreState} from 'app/types/StoreState';
import {Components as Layout} from 'layout';
import withUser from 'user/components/withUser';
import {DataItem} from 'types/model/dataItems/DataItem';

import {loadDataItems} from '../actions';
import DataItemsTable from '../components/DataItemsTable';

interface OuterProps {}

interface StateProps {
    dataItems: DataItem[] | null;
}

interface DispatchProps {
    loadDataItems(): void;
}

type Props = OuterProps & StateProps & DispatchProps;

class List extends Component<Props> {
    componentDidMount(): void {
        const {loadDataItems} = this.props;

        loadDataItems();
    }

    render(): ReactNode {
        const {dataItems} = this.props;

        if (dataItems && isEmpty(dataItems)) {
            return this.renderNoDataItems();
        }

        return (
            <Layout.ListPage title="Datové položky">
                <DataItemsTable
                    dataItems={dataItems}
                />
            </Layout.ListPage>
        );
    }

    private renderNoDataItems(): ReactNode {
        return (
            <Layout.EmptyPage>
                <div className="text-center h5">
                    Zatím nejsou žádné datové položky.
                </div>
            </Layout.EmptyPage>
        );
    }
}

const mapStateToProps = (state: StoreState): StateProps => ({
    dataItems: state.dataItem.dataItems,
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
    loadDataItems: () => dispatch(loadDataItems()),
});

export default flow([
    withUser,
    connect(mapStateToProps, mapDispatchToProps),
])(List) as ComponentClass<OuterProps>;
